import { SelectMultiple } from "@msys/ui";
import { FilterProps } from "../../../commons/filters/index.js";
import {
  FilterChipGroup,
  FilterChipGroupProps,
} from "../../../commons/filters/FilterChip.js";
import { ProjectType } from "../../../../clients/graphqlTypes.js";
import { useTranslate } from "@tolgee/react";
import { useProjectTypes } from "../useProjectTypes.js";

const NO_TYPE_SENTINEL = "__NO_TYPE__";
type SelectValue = ProjectType | typeof NO_TYPE_SENTINEL;
type FilterValue = ProjectType | null;

export function ProjectTypesFilter({
  value,
  setValue,
  ...props
}: FilterProps<FilterValue[]>) {
  const { t } = useTranslate("ProjectTypes");
  const { projectTypeOptions } = useProjectTypes();

  const options: Array<{ value: SelectValue; label: string }> = [
    {
      value: NO_TYPE_SENTINEL,
      label: t("No project type"),
    },
    ...projectTypeOptions,
  ];

  const selectValue: SelectValue[] = (
    Array.isArray(value) ? value : [value]
  ).map(v => (v === null ? NO_TYPE_SENTINEL : v));

  return (
    <SelectMultiple
      label={t("Type")}
      options={options}
      value={selectValue}
      onChange={newValue =>
        setValue(
          newValue.map(v =>
            v === NO_TYPE_SENTINEL ? null : v
          ) as FilterValue[]
        )
      }
      {...props}
    />
  );
}

export function ProjectTypesFilterChips({
  values,
  setValues,
  size,
  color,
  variant,
}: Omit<FilterChipGroupProps<FilterValue>, "label" | "getValueLabel">) {
  const { t } = useTranslate("ProjectTypes");
  const { projectTypeLabels } = useProjectTypes();

  const chipValues: SelectValue[] | undefined = values
    ? (Array.isArray(values) ? values : [values]).map(v =>
        v === null ? NO_TYPE_SENTINEL : v
      )
    : undefined;

  return (
    <FilterChipGroup<SelectValue>
      size={size}
      color={color}
      variant={variant}
      values={chipValues}
      setValues={
        setValues
          ? newValues =>
              setValues(
                newValues?.map(v => (v === NO_TYPE_SENTINEL ? null : v)) as
                  | FilterValue[]
                  | undefined
              )
          : undefined
      }
      getValueLabel={value =>
        value === NO_TYPE_SENTINEL
          ? t("No project type")
          : projectTypeLabels[value as ProjectType]
      }
      label={t("Type")}
    />
  );
}
